// Initialize YouTube functionality when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Load YouTube API
  loadYouTubeAPI();

  // Setup video containers
  initializeVideoContainers();
});

// Global object to store player instances
window.ytPlayers = {};

// Load the YouTube iframe API
function loadYouTubeAPI() {
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  document.getElementsByTagName("script")[0].before(tag);
}

// This function will be called by YouTube API when it's ready
window.onYouTubeIframeAPIReady = () => console.log("YouTube API Ready");

// Initialize all video containers on the page
function initializeVideoContainers() {
  const containers = document.querySelectorAll(".yt-vdo__frame-wrapper");
  if (!containers.length) return;

  containers.forEach((container, index) => {
    const videoId = container.dataset.embed;
    if (!videoId) return;

    // Set unique ID for reference
    container.id = container.id || `yt-container-${index}`;

    // Create thumbnail if needed
    if (!container.querySelector(".yt-vdo__thumbnail-wrapper")) {
      createThumbnail(container, videoId);
    }
  });
}

// Create and load thumbnail with fallback
function createThumbnail(container, videoId) {
  const thumbnailWrapper = document.createElement("div");
  thumbnailWrapper.className = "yt-vdo__thumbnail-wrapper";

  // Preload image to check availability
  const preloadImg = new Image();

  // Get custom title from data attribute
  const videoTitle = container.dataset.title || "YouTube Video";

  // Handle successful image load
  preloadImg.onload = () => {
    const thumbnailImg = document.createElement("img");
    thumbnailImg.className = "yt-vdo__thumbnail-img reset-img";
    thumbnailImg.loading = "lazy";
    thumbnailImg.width = 1000;
    thumbnailImg.height = 1000;
    thumbnailImg.alt = videoTitle || "Ombraz YouTube Video";
    thumbnailImg.src = preloadImg.src;

    thumbnailWrapper.appendChild(thumbnailImg);
    container.appendChild(thumbnailWrapper);

    // Add play button after thumbnail loads
    addPlayButton(container);
  };

  // Handle image load failure - try fallback
  preloadImg.onerror = () => {
    preloadImg.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
  };

  // Try loading high-quality thumbnail first
  preloadImg.src = `https://i.ytimg.com/vi_webp/${videoId}/maxresdefault.webp`;
}

// Add play button to container
function addPlayButton(container) {
  const playButtonWrapper = document.createElement("div");
  playButtonWrapper.className = "yt-vdo__playicon-wrapper";

  const playButton = document.createElement("button");
  playButton.type = "button";
  playButton.className = "yt-vdo__playicon";
  playButton.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" 
         role="presentation" class="icon icon-play" fill="none" viewBox="0 0 10 14">
      <path fill-rule="evenodd" clip-rule="evenodd" 
            d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" 
            fill="transparent" stroke="#fff" stroke-width="0.8px"></path>
    </svg>
  `;

  // Add click event to play button
  playButton.addEventListener("click", (event) => {
    event.preventDefault();
    loadYouTubeVideo(container, container.dataset.embed);
  });

  playButtonWrapper.appendChild(playButton);
  container.appendChild(playButtonWrapper);
}

// Load YouTube video when play button is clicked
function loadYouTubeVideo(container, videoId) {
  // Hide thumbnail and play button
  const thumbnailWrapper = container.querySelector(
    ".yt-vdo__thumbnail-wrapper"
  );
  const playButtonWrapper = container.querySelector(
    ".yt-vdo__playicon-wrapper"
  );

  if (thumbnailWrapper) thumbnailWrapper.classList.add("hide-this");
  if (playButtonWrapper) playButtonWrapper.classList.add("hide-this");

  // Create player container
  const playerDiv = document.createElement("div");
  const playerId = `youtube-player-${container.id}`;
  playerDiv.id = playerId;
  playerDiv.className = "yt-vdo__iframe-container";
  container.appendChild(playerDiv);

  // Initialize player when API is ready
  if (window.YT && window.YT.Player) {
    createYouTubePlayer(playerId, videoId, container);
  } else {
    // Wait for API to load
    const checkInterval = setInterval(() => {
      if (window.YT && window.YT.Player) {
        clearInterval(checkInterval);
        createYouTubePlayer(playerId, videoId, container);
      }
    }, 100);
  }
}

// Create YouTube player with API
function createYouTubePlayer(playerId, videoId, container) {
  window.ytPlayers[playerId] = new YT.Player(playerId, {
    videoId: videoId,
    playerVars: {
      autoplay: 1,
      rel: 0,
      modestbranding: 1,
    },
    events: {
      onStateChange: (event) => {
        // When video ends (state = 0)
        if (event.data === YT.PlayerState.ENDED) {
          resetVideoContainer(container, playerId);
        }
      },
    },
  });
}

// Reset container after video ends
function resetVideoContainer(container, playerId) {
  // Destroy player instance
  if (window.ytPlayers[playerId]) {
    window.ytPlayers[playerId].destroy();
    delete window.ytPlayers[playerId];
  }

  // Remove player element
  const playerContainer = document.getElementById(playerId);
  if (playerContainer) playerContainer.remove();

  // Show thumbnail and play button again
  const thumbnailWrapper = container.querySelector(
    ".yt-vdo__thumbnail-wrapper"
  );
  const playButtonWrapper = container.querySelector(
    ".yt-vdo__playicon-wrapper"
  );

  if (thumbnailWrapper) thumbnailWrapper.classList.remove("hide-this");
  if (playButtonWrapper) playButtonWrapper.classList.remove("hide-this");
}
